import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.adminRiskLevels;
export const adminRiskLevelsSelector = (state: RootState) => getState(state).data;
export const adminRiskLevelsIsLoadingSelector = (state: RootState) => getState(state).isLoading;
export const adminRiskLevelsIsReadySelector = (state: RootState) => getState(state).isReady;
export const adminRiskLevelsErrorSelector = (state: RootState) => getState(state).error;
